import { render, staticRenderFns } from "./PreReservation.vue?vue&type=template&id=98282472&"
import script from "./PreReservation.vue?vue&type=script&lang=js&"
export * from "./PreReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports